import React, { useState } from "react";
import s from "./ReportLayoutManager.module.scss";
import { IllioReportLogo } from "./assets/IllioReportLogo";
import { ReduceIcon } from "./assets/ReduceIcon";
import classNames from "classnames";
import { ReportLayoutButton } from "./components/ReportLayoutButton";
import { ReportLayoutSections } from "./reportLayoutSections";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

export const ReportLayoutManager = () => {
  const [small, setSmall] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const filteredSections = ReportLayoutSections.map((section) => ({
    ...section,
    items: section.items.filter((item) =>
      item.text.toLowerCase().includes(searchQuery.toLowerCase())
    ),
  })).filter((section) => section.items.length > 0);

  return (
    <div className={classNames(s.container, small && s.small)}>
      <div className={s.row}>
        <div className={s.logoContainer}>
          <div className={s.backButton} onClick={() => navigate(-1)}>
            <IoArrowBack size={24} />
          </div>
          <IllioReportLogo />
        </div>
        <div className={s.reduceIcon} onClick={() => setSmall(!small)}>
          <ReduceIcon />
        </div>
      </div>

      <input
        type="text"
        placeholder="Search..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={s.searchInput}
      />
      <div className={s.itemsContainer}>
        {filteredSections.map((section) => (
          <React.Fragment key={section.title}>
            <div className={s.sectionTitle}>{section.title}</div>
            <div className={s.itemsList}>
              {section.items.map((item) => (
                <ReportLayoutButton
                  key={item.id}
                  icon={item.icon}
                  id={item.id}
                  text={item.text}
                />
              ))}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
